import { useEffect, useState } from 'react'

import { useApi } from '../../../../hooks'
import { getEmailProfilePreparedWidgetsData } from '../../EmailProfile'

export function useEmailProfileWidgetsData({
  enabled = true,
  getPreparedData = getEmailProfilePreparedWidgetsData,
  getWidgetsData,
  isInitiated,
}) {
  const api = useApi()

  const [widgetsData, setWidgetsData] = useState(null)

  async function loadWidgetsData() {
    return getWidgetsData().then(({ data }) => {
      setWidgetsData(getPreparedData(data))
    })
  }

  useEffect(() => {
    if (isInitiated && enabled) {
      api.call(loadWidgetsData)
    }

    return () => {
      api.abort()
    }
  }, [isInitiated])

  return {
    loadWidgetsData,
    widgetsData,
  }
}
